import { MarketplaceArche } from '../../lib/api';
import { ArcheCard } from './ArcheCard';

interface ArcheGridProps {
  arches: MarketplaceArche[];
  loading?: boolean;
}

function ArcheCardSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden animate-pulse">
      <div className="aspect-video bg-gray-200" />
      <div className="p-4">
        <div className="h-5 bg-gray-200 rounded w-3/4 mb-2" />
        <div className="h-4 bg-gray-200 rounded w-full mb-1" />
        <div className="h-4 bg-gray-200 rounded w-2/3 mb-3" />
        <div className="flex items-center justify-between">
          <div className="h-6 bg-gray-200 rounded w-20" />
          <div className="h-4 bg-gray-200 rounded w-16" />
        </div>
      </div>
    </div>
  );
}

export function ArcheGrid({ arches, loading = false }: ArcheGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-6">
        {[...Array(8)].map((_, i) => (
          <ArcheCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (arches.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">No arches found</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-6">
      {arches.map((arche) => (
        <ArcheCard key={arche.archId} arche={arche} />
      ))}
    </div>
  );
}
